import type { FC } from 'react'
import { useState, useEffect } from 'react'
import cn from 'classnames'
import { Textarea } from 'components/ui'
import { useCart } from 'hooks/use-cart'
import { CustomerService } from 'modules/customers/services'
import { OrderService } from 'modules/orders/services'
import type { CartNoteProps } from '.'
import s from './cart-note.module.css'

const CartNote: FC<CartNoteProps> = ({ className, orderId }) => {
  const [userNote, setUserNote] = useState<string>(null as unknown as string)
  const { note, setNote } = useCart()

  function onChange(e: any) {
    setUserNote(e.target.value)
  }

  function onBlur() {
    setNote(userNote)
    if (orderId) {
      const customerService = new CustomerService()
      const orderService = new OrderService(customerService)
      orderService.updateComment(orderId, userNote.trim())
    }
  }

  useEffect(() => {
    setUserNote(note)
  }, [note])

  return (
    <div className={cn(s.root, className)}>
      <div className={s.label}>Observação do pedido</div>
      <Textarea
        name="note"
        value={userNote}
        onChange={onChange}
        onBlur={onBlur}
        placeholder="Escreva aqui sua observação sobre esse pedido"
      />
    </div>
  )
}

export default CartNote
